/**
 * UtilityData - Represents network / node metadata for a utility element.
 *
 * Maps to fields from:
 *   - CifSubsurfaceConflictAnalysis.BaseNode_NetworkDataAspect
 *   - CifSubsurfaceConflictAnalysis.ElectricalNode_NetworkDataAspect
 *
 * Values are kept as strings so they can directly hold either raw codes
 * or resolved display text, depending on what the data source provides.
 */
export class UtilityData {
  /** Element Type (User Defined) */
  ElementTypeUserDefined: string;

  /** Network Type (e.g., Power, Comm, Gas) */
  NetworkType: string;

  /** Network Type (User Defined) */
  NetworkTypeUserDefined: string;

  /** Node Type (e.g., Exterior Light) */
  NodeType: string;

  /** Operational Status (e.g., In Service) */
  OperationalStatus: string;

  /** Owner */
  Owner: string;

  constructor(data: {
    ElementTypeUserDefined: string;
    NetworkType: string;
    NetworkTypeUserDefined: string;
    NodeType: string;
    OperationalStatus: string;
    Owner: string;
  }) {
    this.ElementTypeUserDefined = data.ElementTypeUserDefined;
    this.NetworkType = data.NetworkType;
    this.NetworkTypeUserDefined = data.NetworkTypeUserDefined;
    this.NodeType = data.NodeType;
    this.OperationalStatus = data.OperationalStatus;
    this.Owner = data.Owner;
  }

  /**
   * Creates a UtilityData from a plain object (e.g. ECSQL row).
   */
  static fromObject(obj: Partial<UtilityData>): UtilityData {
    return new UtilityData({
      ElementTypeUserDefined:
        obj.ElementTypeUserDefined !== undefined
          ? String(obj.ElementTypeUserDefined)
          : "",
      NetworkType:
        obj.NetworkType !== undefined ? String(obj.NetworkType) : "",
      NetworkTypeUserDefined:
        obj.NetworkTypeUserDefined !== undefined
          ? String(obj.NetworkTypeUserDefined)
          : "",
      NodeType: obj.NodeType !== undefined ? String(obj.NodeType) : "",
      OperationalStatus:
        obj.OperationalStatus !== undefined
          ? String(obj.OperationalStatus)
          : "",
      Owner: obj.Owner !== undefined ? String(obj.Owner) : "",
    });
  }

  /**
   * Convenience empty instance.
   */
  static empty(): UtilityData {
    return new UtilityData({
      ElementTypeUserDefined: "",
      NetworkType: "",
      NetworkTypeUserDefined: "",
      NodeType: "",
      OperationalStatus: "",
      Owner: "",
    });
  }

  /**
   * Converts UtilityData to a plain object (for JSON export, etc.).
   */
  toObject(): Record<string, unknown> {
    return {
      ElementTypeUserDefined: this.ElementTypeUserDefined,
      NetworkType: this.NetworkType,
      NetworkTypeUserDefined: this.NetworkTypeUserDefined,
      NodeType: this.NodeType,
      OperationalStatus: this.OperationalStatus,
      Owner: this.Owner,
    };
  }
}
